import { createSelector } from "@reduxjs/toolkit";

export const selectUnitPageData = createSelector(
  [
    (state, props) => state.facilities.byId[props.facilityId],
    (state, props) => state.units.byId[props.unitId],
    (state, props) => {
      const facility = state.facilities.byId[props.facilityId];
      const recommendedUnitId = facility?.units?.recommendedUnit;
      return recommendedUnitId ? state.units.byId[recommendedUnitId] : undefined;
    },
  ],
  (facility, unit, recommendedUnit) => ({
    facility: facility
      ? { ...facility, recommendedUnit: recommendedUnit || {} }
      : undefined,
    unit: unit || undefined,
  })
);
